import { Children, Fragment, isValidElement, type ReactNode } from "react";
import styles from "./TabList.module.scss";

interface ITabList {
  children: ReactNode;
  stateOwner?: "url" | "react";
}

const InnerContent = ({ children }: Pick<ITabList, "children">) => {
  return (
    <ul className={styles.tabList}>
      {Children.map(children, (child, index) => {
        if (isValidElement(child) && child.type === Fragment) {
          return child;
        }
        return <li key={index}>{child}</li>;
      })}
    </ul>
  );
};

const TabList = ({ children, stateOwner = "url" }: ITabList) => {
  return stateOwner === "url" ? (
    <nav className={styles.tabListWrapper}>
      <InnerContent>{children}</InnerContent>
    </nav>
  ) : (
    <div className={styles.tabListWrapper}>
      <InnerContent>{children}</InnerContent>
    </div>
  );
};

export default TabList;
